// extracted by mini-css-extract-plugin
export default {"bigButton":"BigButton_bigButton__25bKj"};